import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatDateTime'
})
export class FormatDateTimePipe implements PipeTransform {

  transform(milliSecs: number, timeZone: string): any {
    if(!milliSecs)
        return '';
    else{
      let date = new Date(milliSecs);
      if(timeZone)
        date = new Date (date.toLocaleString('en-US', { timeZone }));
      return ('0'+(date.getDate())).slice(-2) + '/' + ('0'+(date.getMonth()+1)).slice(-2) +
             " " +  ('0'+(date.getHours())).slice(-2) + ":" + ('0'+(date.getMinutes())).slice(-2);
    }
  }

}
